import React, { Component } from "react";
import API from "../../Api-config/config";
import { message, notification } from "antd";
import {
  Button,
  Popover,
  PopoverHeader,
  PopoverBody,
  Tooltip,
  Badge,
  Col,
  Row,
  Card,
  CardBody,
  UncontrolledPopover,
  Container,
  Pagination,
  PaginationItem,
  PaginationLink,
  Spinner,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "./documents.scss";

class Documents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false,
      breadcrumbItems: [
        { title: "Delisted Stocks", link: "#" },
        { title: "Documents Uploaded", link: "#" },
      ],
    };
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  };

  handleView = (filename) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        firmName: sessionStorage
          .getItem("username")
          .replace(/[^A-Za-z0-9_]/gi, "_"),
        filename: filename,
      }),
    };
    fetch(API.api_route + "/aws/retreivefromawss3forBilling", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          if (false) {
            notification.error({ message: "No such file is saved " });
          } else {
            message.success("file retreive successfully !");
            window.open(data.url);
            console.log(data.url);
          }
        } else {
          notification.error({
            message: "No such file is saved, kindly upload the file first",
          });
        }
      });
  };
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Documents Uploaded"
              breadcrumbItems={this.state.breadcrumbItems}
            />

            <Row>
              <Col lg={10}>
                <Card>
                  <CardBody>
                    <Row>
                      <Col lg={12}>
                        <div>
                          <h4 className="card-title">Documents</h4>
                          <hr></hr>
                          <Row>
                            <Col lg={6}>
                              <p className="document-name">Adhaar Card.jpg</p>
                            </Col>
                            <Col lg={6} style={{ textAlign: "right" }}>
                              <a>
                                <i
                                  onClick={() => this.handleView("aadhar.pdf")}
                                  class="ri-eye-fill"
                                ></i>
                              </a>
                              {/* <a>
                                <i
                                  style={{ fontSize: "20px" }}
                                  onClick={() =>
                                    this.handleVerify("aadhar.pdf")
                                  }
                                  id="TooltipExample"
                                  class="ri-checkbox-circle-fill ml-3"
                                ></i>
                              </a> */}
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6}>
                              <p className="document-name">Pan Card.jpg</p>
                            </Col>
                            <Col lg={6} style={{ textAlign: "right" }}>
                              <a>
                                <i
                                  onClick={() => this.handleView("panDoc.pdf")}
                                  class="ri-eye-fill"
                                ></i>
                              </a>
                              <a>
                                <i
                                  id="TooltipExample"
                                  style={{ fontSize: "20px" }}
                                  onClick={() =>
                                    this.handleVerify("aadhar.pdf")
                                  }
                                  class="ri-checkbox-circle-fill ml-3"
                                ></i>
                              </a>
                              <Tooltip
                                placement="right"
                                isOpen={this.state.tooltipOpen}
                                target="TooltipExample"
                                toggle={this.toggle}
                              >
                                Verify Document
                              </Tooltip>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg={6}>
                              <p className="document-name">Address Proof.jpg</p>
                            </Col>
                            <Col lg={6} style={{ textAlign: "right" }}>
                              <a>
                                <i
                                  onClick={() =>
                                    this.handleView("addressDoc.pdf")
                                  }
                                  class="ri-eye-fill"
                                ></i>
                              </a>
                              {/* <a>
                                <i
                                  style={{ fontSize: "20px" }}
                                  onClick={() =>
                                    this.handleVerify("aadhar.pdf")
                                  }
                                  id="TooltipExample"
                                  class="ri-checkbox-circle-fill ml-3"
                                ></i>
                              </a> */}
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default Documents;
